import { useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const PRESETS = [
  "Modern (not ancient)",
  "Duplicate entry",
  "Not a structure",
  "Poor data / stub",
  "Off-topic",
];

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

// Controlled dialog that collects a removal reason (quick-pick preset or custom).
export const ReasonDialog = ({ open, onOpenChange, title, description, onConfirm }) => {
  const [custom, setCustom] = useState("");

  const choose = (reason) => {
    onConfirm(reason);
    onOpenChange(false);
    setCustom("");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="reason-dialog">
        <DialogTitle className="font-serif text-xl">{title}</DialogTitle>
        <DialogDescription>{description}</DialogDescription>

        <div className="mt-3 grid gap-2">
          {PRESETS.map((r) => (
            <button
              key={r}
              data-testid={`reason-preset-${slug(r)}`}
              onClick={() => choose(r)}
              className="text-left border border-border px-4 py-2.5 font-mono text-xs uppercase tracking-widest text-foreground hover:border-accent hover:bg-accent/5 transition-colors"
            >
              {r}
            </button>
          ))}
        </div>

        <div className="mt-3 flex gap-2">
          <input
            data-testid="reason-custom-input"
            value={custom}
            onChange={(e) => setCustom(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") choose(custom.trim()); }}
            placeholder="Other reason (optional)"
            className="flex-1 bg-background border border-border px-3 py-2.5 text-sm focus:outline-none focus:border-accent"
          />
          <button
            data-testid="reason-confirm"
            onClick={() => choose(custom.trim())}
            className="bg-accent text-accent-foreground font-mono text-[11px] uppercase tracking-widest px-4 py-2.5 hover:bg-accent/90 transition-colors"
          >
            Remove
          </button>
        </div>

        <button
          data-testid="reason-cancel"
          onClick={() => onOpenChange(false)}
          className="mt-1 font-mono text-[11px] uppercase tracking-widest text-muted-foreground hover:text-foreground"
        >
          Cancel
        </button>
      </DialogContent>
    </Dialog>
  );
};
